<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-title>Legacy Job History Detail</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>

        <ion-card-content>
            <ion-label *ngIf="job.engineer">Engineer:</ion-label>
            <ion-item lines="none" *ngIf="job.engineer">
                <ion-label>
                    {{ job.engineer.name }} <span *ngIf="job.complete">{{job.complete | date:'dd/MM/yyyy'}}</span>
                </ion-label>
            </ion-item>

            <ion-label *ngIf="job.noteText">Note:</ion-label>
            <ion-item lines="none" *ngIf="job.noteText">
                <ion-label text-wrap>
                    {{ job.noteText }}
                </ion-label>
            </ion-item>

            <ion-label *ngIf="job.spares.length > 0">Spares:</ion-label>
            <ion-item *ngFor="let spare of job.spares">
                <ion-label *ngIf="spare.description">
                    {{ spare.description }}
                </ion-label>
            </ion-item>

            <ion-label *ngIf="job.meterReadings.length > 0">Meter Readings:</ion-label>
            <ion-item *ngFor="let mr of job.meterReadings">
                <ion-label *ngIf="mr.description">
                    {{ mr.description }} - {{ mr.value }}
                </ion-label>
            </ion-item>


            <ion-label *ngIf="job.tasks.length != 0">Tasks:</ion-label>
            <ion-item *ngFor="let task of job.tasks">
                <ion-label>{{ task.description }}</ion-label>
                <ion-icon slot="end" [name]="tasksIcon.getIcon(task.option)"
                          [color]="tasksIcon.getColor(task.option)"></ion-icon>
            </ion-item>

        </ion-card-content>
    </ion-card>

</ion-content>
